import { iconCertificate, iconHome, iconService, iconTeleWhite, iconGift } from 'assets/icons';
import cls from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from 'constants/appRoutes';
import { LINK_DEV } from 'constants/index';

export default function MenuBottom(props) {
  const loginRed = useSelector((state) => state.LoginReducer?.menus?.obj) || [];
  const giftItem = loginRed.find((item) => item?.menuId === 'loyalty-profile');

  return (
    <div className='fixed bottom-0 left-0 z-10 flex h-72px w-screen bg-menu-bottom'>
      <MenuItem icon={iconHome} text='Trang chủ' link={AppRoutes.home} />
      <MenuItem icon={iconCertificate} text='Hợp đồng' link={''} />
      {giftItem && <MenuItem icon={iconGift} text='Quà tặng' link={giftItem?.menuPath} />}
      {/* <MenuItem icon={iconGift} text='Quà tặng' link={AppRoutes.gift} /> */}
      <MenuItem icon={iconService} text='Dịch vụ' link={AppRoutes.productsAndServices} />
      <MenuItem icon={iconTeleWhite} text='Liên hệ' link={AppRoutes.contactUs} />
    </div>
  );
}

const MenuItem = ({ icon, text, link }) => {
  let location = useLocation();

  const isActive = location.pathname === link;

  const onChange = () => {
    if(link !== '/pages/loyalty-store'){
			window.location.href = `${LINK_DEV}${link}`
		}
  };

  return (
    <div
      className={cls({
        'flex flex-1 cursor-pointer flex-col items-center justify-center': true,
        'bg-menu-active': isActive,
      })}
      onClick={onChange}
    >
      <div className='flex items-center justify-center'>
        <img src={icon} width={20} alt='' />
      </div>
      <p className='mt-4px text-center font-roboto-medium text-11px text-white'>{text}</p>
    </div>
  );
};
